import React from 'react'
import { createContext } from 'src/util'
import countBy from 'lodash/countBy'

const countPaths = ({ to }) => (to === '/' ? 0 : countBy(to)['/'])
const PUT = Symbol()
const REMOVE = Symbol()

/**
 * Creates a context for getting and setting the array of breadcrumbs.
 */
export default createContext(
  Provider =>
    function BreadcrumbsContext(props) {
      // create breadcrumbs state
      const [breadcrumbs, dispatch] = React.useReducer((state, action) => {
        switch (action.type) {
          case PUT: {
            const breadcrumbs = state.find(breadcrumb => breadcrumb.to === action.to)
              ? // replace breadcrumb item if it already exists
                state.map(
                  breadcrumb => (breadcrumb.to === action.to && { to: action.to, ...action.breadcrumb }) || breadcrumb
                )
              : // otherwise add it
                [...state, { to: action.to, ...action.breadcrumb }]
            // sort breadcrumbs by number of uri paths
            return breadcrumbs.sort((breadcrumb1, breadcrumb2) => countPaths(breadcrumb1) - countPaths(breadcrumb2))
          }

          case REMOVE: {
            return state.filter(breadcrumb => breadcrumb.to !== action.to)
          }

          default:
            return state
        }
      }, [])

      const putBreadcrumb = React.useCallback(
        (to, breadcrumb) =>
          dispatch({
            type: PUT,
            to,
            breadcrumb,
          }),
        []
      )

      const removeBreadcrumb = React.useCallback(
        to =>
          dispatch({
            type: REMOVE,
            to,
          }),
        []
      )

      return (
        <Provider
          {...props}
          value={{
            breadcrumbs,
            putBreadcrumb,
            removeBreadcrumb,
          }}
        />
      )
    }
)
